// CartContext.js
import React, { createContext, useState, useContext, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../authmanager/authcontext";
import { getCart, createCart,deleteCart  } from "../utils/utils";
import ProductDescription from "../validators/descriptor";
import Navbar from "../navbar/navbar";
const CartContext = createContext();
const FinalizedCart = ({toggleTheme}) => {
  const navigate = useNavigate();
  const [success, setSuccessMessage] = useState(false);
  const [cartReviewValue, setFinalCartReview] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { isLoggedIn,finalizeCart,handleLogout } = useContext(AuthContext);
  const { cartItems } = useContext(CartContext);
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    const handleSignup = async () => {
      try {
        setIsLoading(true);
        // Fetch the cart items
        let cart = await getCart(accessToken);

        if (cart.length === 0) {
          console.log("Cart is empty.", cartItems, cartItems.length);
          const createCartPromises = [];
          for (let i = 0; i < cartItems.length; i++) {
            createCartPromises.push(
              createCart(accessToken, cartItems[i].id, cartItems[i].quantity)
            );
          }
          const createdCarts = await Promise.all(createCartPromises);

          for (const createdCart of createdCarts) {
            if (createdCart.status !== 200) {
              console.error("Failed to create cart item:", createdCart.data);
            }
          }
          const finalCart = await getCart(accessToken);
          if (finalCart.status !== 200) {
            console.error("Failed to create cart item:", finalCart.data);
          }
          console.log("finalCart", finalCart);
          setFinalCartReview(finalCart);
        } else {
          console.log("Cart is Already created");
          setFinalCartReview(cart);
        }
      } catch (error) {
        console.error("Error:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    if (isLoggedIn) {
      handleSignup();
    }
  }, [accessToken, isLoggedIn]);
  const handleCartResetClick = () => {
    deleteCart(accessToken);
    setSuccessMessage("Cart Deleted");
    navigate("/home");
  };
  const handlerProceedToCheckout = () => {
    navigate("/checkout");
  };
  return (
    <div>
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>{error}</p>
      ) : isLoggedIn ? (
        <div>
          <Navbar toggleTheme={toggleTheme} handleLogout={handleLogout} finalizeCart={finalizeCart} />
              <br></br>
          
          <div className="button-container">
                   
          <button onClick={handlerProceedToCheckout} className="circle">
            proceed to place an order
          </button>
          <button onClick={handleCartResetClick} className="circle">Back to Selection</button>
          </div>
          <h3>Review the final items</h3>
          <div className="product-grid">
          {/* Add this log to check cartReviewValue */}
          {console.log("Rendering with cartReviewValue:", cartReviewValue)}
          {cartReviewValue.length ? (
            cartReviewValue.map((cartItem) => (
              <div key={cartItem.id}>
                <img
                  src={cartItem.product.image}
                  alt={cartItem.product.name}
                
                  className="product-image"
                  ></img>
                <h3>{cartItem.product.name}</h3>
                <ProductDescription description={cartItem.product.longDescription} />
                <p>Price: {cartItem.product.price}</p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span>Quantity: {cartItem.quantity}</span>
                  {/* Add buttons or actions for managing cart items */}
                </div>
              </div>
            ))
          ) : (
            <p>Cart Is Empty</p>
          )}
          </div>
          
        </div>
        
      ) : (
        <Link to="/login">Please login via </Link>
      )}
    </div>
  );
};
const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [finalized, setIsFinalized] = useState(false);
  const navigate = useNavigate();
  const addToCart = (product, quantity = 1) => {
    quantity = parseInt(quantity, 10);
    const existingItemIndex = cartItems.findIndex(
      (item) => item.id === product.id
    );
    if (existingItemIndex !== -1) {
      // If the product already exists in the cart, update its quantity
      const updatedCartItems = [...cartItems];

      updatedCartItems[existingItemIndex].quantity += quantity;
      setCartItems(updatedCartItems);
    } else {
      // If the product is not in the cart, add it with the specified quantity
      setCartItems([...cartItems, { ...product, quantity }]);
    }
  };
  const showCartItems = (product) => {
    if (!cartItems.length) {
      return 0; // Return 0 if cartItems is empty
    }
    const existingItemIndex = cartItems.findIndex(
      (item) => item.id === product.id
    );
    if (existingItemIndex === -1) {
      return 0; // Return 0 if product is not found in cartItems
    }
    const CartItems = [...cartItems];
    return CartItems[existingItemIndex].quantity;
  };

  const removeProductByQuantityFromCart = (product, quantity) => {
    const existingItemIndex = cartItems.findIndex(
      (item) => item.id === product.id
    );
    quantity = parseInt(quantity, 10);
    const updatedCartItems = [...cartItems];
    if (updatedCartItems[existingItemIndex].quantity === 1 && quantity == 1) {
      removeFromCart(product);
    }
    updatedCartItems[existingItemIndex].quantity -= quantity;
  };
  const finalizeCart = () => {
    setIsFinalized(true);
    // Perform finalization actions, such as navigating to the cart page
    navigate("/cart");
  };

  const resetCart = () => {
    setCartItems([]);
    setIsFinalized(false);
  };

  const removeFromCart = (product) => {
    setCartItems(cartItems.filter((item) => item.id !== product.id));
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        showCartItems,
        removeProductByQuantityFromCart,
        finalizeCart,
        resetCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export { CartContext, CartProvider, FinalizedCart };
